import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon } from 'antd'
import { app, api, config } from '../../../../app'

import html2canvas from 'html2canvas';



class NoCrimeUndertaking extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let data = {          //注册表内容
            d1: '',
            d2: '',
            d3: '',
            d4: '',
            d5: '',
            d6: '',
            d7: '',
            d8: '',
            d9: ''
        }
        let uploadImgList = []
        let uploadImgList2 = []
        let whiteOK2 = false
        // console.log(props)
        if(props.fileInfo.length <=0){

        }else if(props.fileInfo[4].data != undefined) {
            if (props.fileInfo[4].data.d1 != undefined) {

                data = props.fileInfo[4].data
                whiteOK2 = true
                // console.log(data)
                this.props.criminal_record_json(data, 'data')
    
            }
    
            if (props.fileInfo[4].img != '') {
                uploadImgList2 = props.fileInfo[4].img.split(';;;')
                this.props.criminal_record_json(uploadImgList2, 'img')
    
            }
    
            if (props.fileInfo[5].img != '') {
                uploadImgList = props.fileInfo[5].img.split(';;;')
                this.props.criminal_record_json(uploadImgList, 'zhengmingshu')
            }

    
        }
        



        // 申请详情

        if (props.com4.data != undefined) {
            data = props.com4.data
            if (props.com4.img != '') {
                uploadImgList2 = props.com4.img.split(';;;')
            }
        }

        // if(props.com5.img != ''){
        //     uploadImgList = props.com5.img.split(';;;')
        // }
        // console.log(whiteOK2)
        this.state = {
            fileInfo: props.fileInfo,   //初始数据，一进入组件就请求获得

            isModalVisible: false,
            isModalVisible2: false,
            // whiteModal: false,

            NoCrimeUndertakingImg: '',
            NoCrimeUndertakingImg2: '',
            submitOK: false,

            data: data,


            showInfoImg: false,
            showInfoImg2: false,

            uploadImgList: uploadImgList,
            showMoadlImg: '',
            imgModal: false,
            whiteOK: false,  //是否已经提交过内容
            whiteModal: false,    //是否打开 注册申请表 编辑窗口
            defaultImgList: [],

            uploadImgList2: uploadImgList2,
            showMoadlImg2: '',
            imgModal2: false,
            whiteOK2: whiteOK2,  //是否已经提交过内容
            whiteModal2: false,    //是否打开 注册申请表 编辑窗口
            defaultImgList2: []

        }

    }

    componentDidMount() {
        this.getDefaultImg()
        this.getExamineInfo()
        this.getApplyinfo()
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            const applyinfo = app.getData('applyinfo');
            // console.log(applyinfo)

            if (applyinfo.file[5].img == "") {
                let uploadImgList2 = applyinfo.file[4].img.split(';;;')
                this.props.criminal_record_json(applyinfo.file[4].data, 'data')
                this.props.criminal_record_json(uploadImgList2, 'img')

                this.setState({
                    uploadImgList2,
                    data: applyinfo.file[4].data,
                    whiteOK2: true
                })
            }
            if (applyinfo.file[5].img != "") {
                let uploadImgList = applyinfo.file[5].img.split(';;;')
                this.props.criminal_record_json(uploadImgList, 'zhengmingshu')

                this.setState({
                    uploadImgList
                })
            }

        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');
            console.log(examineInfo)
            let uploadImgList = this.state.uploadImgList;
            if (examineInfo.file[4].name == "无犯罪记录证明书") {
                uploadImgList = examineInfo.file[4].img.split(';;;')
                this.setState({
                    uploadImgList
                })
            } else {
                let uploadImgList2 = examineInfo.file[4].img.split(';;;')
                this.setState({
                    uploadImgList2,

                })
            }
        }
    }

    //对默认展示图片进行处理
    getDefaultImg = () => {
        if(this.props.fileInfo.length <= 0){
            return
        }
        let defaultImgList = this.props.fileInfo[5].template_img.split(';;;')
        let defaultImgList2 = this.props.fileInfo[4].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList,
            defaultImgList2
        })
    }


    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        let uploadImgList = this.state.uploadImgList;
        if (examineInfo.file[5].name == "无犯罪记录证明书") {
            uploadImgList = examineInfo.file[5].img.split(';;;')
            this.setState({
                uploadImgList
            })
        } else {
            let uploadImgList2 = examineInfo.file[4].img.split(';;;')
            this.setState({
                uploadImgList2,

            })
        }


    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = this.props.applyinfo;
        // console.log(applyinfo)

        if (applyinfo.file[5].img == "") {
            let uploadImgList2 = applyinfo.file[4].img.split(';;;')
            this.props.criminal_record_json(applyinfo.file[4].data, 'data')
            this.props.criminal_record_json(uploadImgList2, 'img')

            this.setState({
                uploadImgList2,
                data: applyinfo.file[4].data,
                whiteOK2: true
            })
        } else {
            let uploadImgList = applyinfo.file[5].img.split(';;;')
            this.props.criminal_record_json(uploadImgList, 'zhengmingshu')

            this.setState({
                uploadImgList
            })
        }


    }

    showModal = () => {
        this.setState({
            isModalVisible: true
        })
    }

    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    }

    showModal2 = () => {
        this.setState({
            isModalVisible2: true
        })
    }

    handleCancel2 = () => {
        this.setState({
            isModalVisible2: false
        })
    }

    showInfoImg = () => {
        this.setState({
            showInfoImg: true
        })
    }

    showInfoImgCencel = () => {
        this.setState({
            showInfoImg: false
        })
    }

    showInfoImg2 = () => {
        this.setState({
            showInfoImg2: true
        })
    }

    showInfoImg2Cencel = () => {
        this.setState({
            showInfoImg2: false
        })
    }

    Openfill = () => {
        this.setState({
            whiteModal: true
        })
    }

    submit = () => {
        const { data } = this.state
        if (data.d1 == '') {
            app.alert('申请人姓名未填写', 'error', '45%')
            return
        }

        if (data.d2 == '') {
            app.alert('申请人性别未填写', 'error', '45%')
            return
        }


        if (data.d3 == '') {
            app.alert('申请人身份证号码未填写', 'error', '45%')
            return
        }

        if (data.d4 == '') {
            app.alert('承诺日期年份未填写', 'error', '45%')
            return
        }

        if (data.d5 == '') {
            app.alert('承诺日期月份未填写', 'error', '45%')
            return
        }
        if (data.d6 == '') {
            app.alert('承诺日期未填写', 'error', '45%')
            return
        }

        if (data.d7 == '') {
            app.alert('承诺日期年份未填写', 'error', '45%')
            return
        }


        if (data.d8 == '') {
            app.alert('承诺日期月份未填写', 'error', '45%')
            return
        }

        if (data.d9 == '') {
            app.alert('承诺日期未填写', 'error', '45%')
            return
        }


        // console.log(data)
        this.props.criminal_record_json(data, 'data')
        this.setState({
            whiteModal: false,
            whiteOK2: true
        })
    }

    _changeValue = (e) => {
        const { data } = this.state;
        data[e.target.name] = e.target.value.trim()
        this.setState({
            data
        })
    }

    ShutDownFill = () => {
        this.setState({
            whiteModal: false
        })
    }


    // goDownload = () => {
    //     this.setState({
    //         whiteModal: true
    //     }, () => {
    //         this.downloadJPG('NoCrimeUndertakingJPG', '无犯罪记录承诺书')
    //     })
    // }


    downloadJPG = async (DOMId, fileName) => {
        let ppg = document.getElementById(DOMId);

        html2canvas(ppg, {
            allowTaint: false,
            useCORS: true,
        }).then(canvas => {
            // toImage
            const dataImg = new Image()
            dataImg.src = canvas.toDataURL('image/png')
            const alink = document.createElement("a");
            alink.href = dataImg.src;
            alink.download = fileName + ".png";
            alink.click();
            this.setState({
                whiteModal: false
            })
        });
    }




    // {/* 存心救援队注册申请表 */}
    clickImg = (i) => {
        // console.log(i.target.getAttribute('data-img'))
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleImg_criminal_record_json(i,1)
        this.props.criminal_record_json(uploadImgList, 'zhengmingshu')

        this.setState({
            uploadImgList
        })
    };


    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    };


    // {/* 存心救援队注册申请表 */}
    clickImg2 = (i) => {
        // console.log(i.target.getAttribute('data-img'))
        this.setState({
            imgModal2: true,
            showMoadlImg2: i.target.getAttribute('data-img')
        })
    };

    deleImg2 = (i) => {
        const { uploadImgList2 } = this.state;
        uploadImgList2.splice(i, 1)
        // this.props.deleImg_criminal_record_json(i,2)
        this.props.criminal_record_json(uploadImgList2, 'img')

        this.setState({
            uploadImgList2
        })
    };


    clickImgCencel2 = () => {
        this.setState({
            imgModal2: false
        })
    };



    white = () => {

        this.setState({
            whiteModal: true
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }

    downLoad = (blobUrl) => {

        let that = this;
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("key", 'criminal_record');
        fd.append("file_data", JSON.stringify(this.state.data));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                // console.log(blob)
                that.downloadFile1(blob, 'pdf', '无犯罪记录承诺书.pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        // console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }


    uploadImg = (info) => {
        if(info.file.status === 'uploading'){
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                // console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;
                // this.props.reg_file_json(img, 'img')
                const { uploadImgList } = this.state;
                uploadImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.criminal_record_json(uploadImgList, 'zhengmingshu')
                this.setState({
                    uploadImgList,
                    whiteOK2: false
                },()=>{
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }


    uploadImg2 = (info) => {
        if(info.file.status === 'uploading'){
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                // console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;
                // this.props.reg_file_json(img, 'img')
                const { uploadImgList2 } = this.state;
                uploadImgList2.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.criminal_record_json(uploadImgList2, 'img')

                this.setState({
                    uploadImgList2
                },()=>{
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }


    // lastImg = () => {
    //     let showMoadlImg = this.state.showMoadlImg;
    //     const { uploadImgList } = this.state;
    //     let index
    //     uploadImgList.forEach((i, v) => {
    //         if (i == showMoadlImg) {
    //             if (v == 0) {
    //                 index = v
    //                 app.alert("没有更多图片了", 'error', '45%')
    //                 return
    //             } else {
    //                 index = v
    //             }
    //         }
    //     })
    //     if (index == 0) {
    //         return
    //     }
    //     showMoadlImg = uploadImgList[index - 1]
    //     this.setState({
    //         showMoadlImg
    //     })
    // }






    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = defaultImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }



    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if ( v == defaultImgList.length - 1) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v

                    }
                }
            })
            if ( index == defaultImgList.length - 1) {
                return
            } else {
                showMoadlImg = defaultImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if ( v == uploadImgList.length - 1) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v

                    }
                }
            })
            if ( index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }
        // uploadImgList.forEach((i, v) => {
        //             if (i == showMoadlImg) {
        //                 if (v == uploadImgList.length - 1) {    //当前是最后一张
        //                     index = v
    
        //                     app.alert("没有更多图片了", 'error', '45%')
        //                     return
        //                 } else {
        //                     index = v
    
        //                 }
        //             }
        //         })
        //         if (index == uploadImgList.length - 1) {
        //             return
        //         } else {
        //             showMoadlImg = uploadImgList[index + 1]
        //             this.setState({
        //                 showMoadlImg
        //             })
        //         }


    }


    lastImg2 = () => {
        let showMoadlImg2 = this.state.showMoadlImg2;
        const { uploadImgList2, defaultImgList2 } = this.state;
        let index
        if (uploadImgList2.length < 1) {
            defaultImgList2.forEach((i, v) => {
                if (i == showMoadlImg2) {
                    if (v == 0) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                    } else {
                        index = v

                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg2 = defaultImgList2[index - 1]
                this.setState({
                    showMoadlImg2
                })
            }
        } else {
            uploadImgList2.forEach((i, v) => {
                if (i == showMoadlImg2) {
                    if (v == 0) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                    } else {
                        index = v

                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg2 = uploadImgList2[index - 1]
                this.setState({
                    showMoadlImg2
                })
            }
        }


    }

    nextImg2 = () => {
        let showMoadlImg2 = this.state.showMoadlImg2;
        const { uploadImgList2, defaultImgList2 } = this.state;
        let index
        if (uploadImgList2.length < 1) {
            defaultImgList2.forEach((i, v) => {
                if (i == showMoadlImg2) {
                    if (v == defaultImgList2.length - 1) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v


                    }
                }
            })
            if (index == defaultImgList2.length - 1) {
                return
            } else {
                showMoadlImg2 = defaultImgList2[index + 1]
                this.setState({
                    showMoadlImg2
                })
            }
        } else {
            uploadImgList2.forEach((i, v) => {
                if (i == showMoadlImg2) {
                    if (v == uploadImgList2.length - 1) {
                        index = v

                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v


                    }
                }
            })
            if (index == uploadImgList2.length - 1) {
                return
            } else {
                showMoadlImg2 = uploadImgList2[index + 1]
                this.setState({
                    showMoadlImg2
                })
            }
        }



        // uploadImgList2.forEach((i, v) => {
        //     if (i == showMoadlImg2) {
        //         if (v == uploadImgList2.length - 1) {    //当前是最后一张
        //             index = v

        //             app.alert("没有更多图片了", 'error', '45%')
        //             return
        //         } else {
        //             index = v

        //         }
        //     }
        // })
        // if (index == uploadImgList2.length - 1) {
        //     return
        // } else {
        //     showMoadlImg2 = uploadImgList2[index + 1]
        //     this.setState({
        //         showMoadlImg2
        //     })
        // }


    }






    // 页面渲染区
    render() {
        let { fileInfo, NoCrimeUndertakingImg, NoCrimeUndertakingImg2, uploadImgList, uploadImgList2, defaultImgList, defaultImgList2, data } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )

        const content2 = (
            <div>
                <p>《无犯罪记录证明书》和《无犯罪记录承诺书》只需上传其中一样即可，优先上传无犯罪记录证明书。</p>
                <p>《无犯罪记录证明书》需要本人到公安局或者派出所开具</p>
            </div>
        )


        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>

                        }
                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        const defaultImg = defaultImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>
                // <img style={{ width: 90, height: 100, marginRight: 5 }} onClick={this.clickImg} data-img={item} key={item} src={config.imgUrl + item} alt="" />

            )
        })

        const imgList2 = uploadImgList2.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg2} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg2(index)}>删除</p>

                        }

                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        const defaultImg2 = defaultImgList2.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg2} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>


                // <img style={{ width: 90, height: 100, marginRight: 5 }} onClick={this.clickImg2} data-img={item} key={item} src={config.imgUrl + item} alt="" />

            )
        })
        return (


            <div >
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal}>《无犯罪记录证明书》</span>
                        </Popover>

                        <Popover content={content}>
                            <span style={{ cursor: 'pointer', marginLeft: 40 }} onClick={this.showModal2}>《无犯罪记录承诺书》</span>
                        </Popover>

                        <Popover content={content2}>
                            <Icon type="question-circle" style={{ color: 'grey', fontSize: 14 }} />
                        </Popover>



                        <Modal title="无犯罪记录证明书" visible={this.state.isModalVisible} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel}>


                            {
                                defaultImgList.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5,borderBottom:3,borderBottomStyle:'solid',borderBottomColor:'#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }

                        </Modal>
                        <Modal title="无犯罪记录承诺书" visible={this.state.isModalVisible2} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel2}>


                            {
                                defaultImgList2.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5,borderBottom:3,borderBottomStyle:'solid',borderBottomColor:'#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }

                        </Modal>
                    </p>
                    {/* 标题end */}

                    {/* 资料框 */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '50%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                                <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                    {
                                        uploadImgList.length < 1
                                            ?
                                            defaultImg
                                            :
                                            imgList
                                    }

                                </div>


                                <Modal title="无犯罪记录证明书" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                                    <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                        <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                            <Icon type="left" ></Icon> 上一张
                                    </div>
                                        <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                            下一张<Icon type="right" ></Icon>
                                        </div>
                                    </p>
                                    {

                                        <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                    }
                                </Modal>


                            </div>



                            {this.props.examine == 1 || this.props.detailF == 1 ? '' : uploadImgList2.length >= 1 ? '' : uploadImgList.length == 3
                                ?
                                <div style={{ marginTop: 5 }} >上传</div>
                                :
                                <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                    <Upload
                                        accept='image/jpeg, image/jpg, image/png'
                                        showUploadList={false}
                                        action={config.serverUrl + "/TeamApply/imageUpload"}
                                        name="image"
                                        onChange={this.uploadImg}
                                        style={{ color: '#1890FF' }}>上传</Upload>
                                </div>}

                        </div>













                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '50%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                                <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                    {
                                        uploadImgList2.length < 1
                                            ?
                                            defaultImg2
                                            :
                                            imgList2
                                    }

                                </div>


                                <Modal title="无犯罪记录承诺书" visible={this.state.imgModal2} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel2}>
                                    <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                        <div style={{ cursor: 'pointer' }} onClick={this.lastImg2}>
                                            <Icon type="left" ></Icon> 上一张
                                    </div>
                                        <div style={{ cursor: 'pointer' }} onClick={this.nextImg2}>
                                            下一张<Icon type="right" ></Icon>
                                        </div>
                                    </p>
                                    {

                                        <img src={config.imgUrl + this.state.showMoadlImg2} alt="" style={{ width: 1000 }} />
                                    }
                                </Modal>


                            </div>
                            {
                                this.props.examine == 1 || this.props.detailF == 1 ? '' : uploadImgList.length >= 1 ? '' : !this.state.whiteOK2
                                    ?
                                    <div >
                                        <div style={{ cursor: 'pointer', color: '#1890FF' }} onClick={this.Openfill}>填写</div>
                                        <div style={{ marginTop: 5 }}>下载</div>
                                        <div style={{ marginTop: 5 }} >上传</div>
                                    </div>
                                    :
                                    <div >
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.Openfill}>编辑</div>
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.downLoad}>
                                            下载
            </div>


                                        {uploadImgList2.length == 3
                                            ?
                                            <div style={{ marginTop: 5 }} >上传</div>
                                            :
                                            <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                                <Upload
                                                    accept='image/jpeg, image/jpg, image/png'
                                                    showUploadList={false}
                                                    action={config.serverUrl + "/TeamApply/imageUpload"}
                                                    name="image"
                                                    onChange={this.uploadImg2}
                                                    style={{ color: '#1890FF' }}>上传</Upload>
                                            </div>}




                                    </div>

                            }
                        </div>

                    </div>
                    {/* 资料框 */}





                    <div style={{ width: 70, paddingLeft: 10, }}>
                        <Modal title="无犯罪记录承诺书" visible={this.state.whiteModal} width={1250} footer={null} onCancel={this.ShutDownFill} style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ width: '100%', padding: 80, height: 1350, fontSize: 22 }} id="JPGDOM">
                                {/* 展示栏 */}
                                <p style={{ textAlign: 'center', fontSize: 34, }}>无犯罪记录承诺书</p>
                                <p style={{ textIndent: '2em' }}>
                                    本人<input type="text" onChange={this._changeValue} name="d1" value={data.d1} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />，
                                        性别<input type="text" onChange={this._changeValue} name="d2" value={data.d2} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />，
                                        身份证号码<input type="text" onChange={this._changeValue} name="d3" value={data.d3} style={{ outline: 'idno', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', }} />，
                                        承诺在<input type="text" onChange={this._changeValue} name="d4" value={data.d4} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        年<input type="text" onChange={this._changeValue} name="d5" value={data.d5} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        月
                                        <input type="text" onChange={this._changeValue} name="d6" value={data.d6} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        日至
                                        <input type="text" onChange={this._changeValue} name="d7" value={data.d7} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        年<input type="text" onChange={this._changeValue} name="d8" value={data.d8} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        月<input type="text" onChange={this._changeValue} name="d9" value={data.d9} style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid', width: 100 }} />
                                        日期间无违法犯罪记录或参加邪教组织情况。</p>
                                <p style={{ textIndent: '2em' }}>本人承诺上述信息真实有效，如有虚假信息，将被取消相关资格，一切后果自负。</p>

                                <p style={{ textIndent: '25em', paddingTop: 300 }}>承诺人：<span style={{ color: '#ccc', fontSize: 16 }}>签名加盖手指印</span></p>
                                <p style={{ textIndent: '25em' }}>承诺日期：_______年_______月_______日</p>


                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.submit}>提交</Button>
                                <Button style={{ width: 200 }} onClick={this.ShutDownFill}>关闭</Button>
                                <div onClick={this.downloadJPG}></div>
                            </div>
                        </Modal>



                    </div>
                </div>
            </div >



        )
    }
}



export default NoCrimeUndertaking



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/NoCrimeUndertaking.jsx